<template>
  <b-overlay :show="estoreIsLoadingOverlay" rounded="sm">
    <b-modal
      class="fade"
      id="product_details"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      ref="modal"
      size="sm"
      v-if="specificProduct != null"
      centered
      scrollable
    >
      <template v-slot:modal-header>
        <div
          class="banner-content"
          :style="{
            backgroundImage: specificProduct.product_details.images.length ?
              'url(' +
              specificProduct.product_details.images[0].image_name +
              ')' : '',
            height: '310px'
          }"
        >
          <div :class="['p-2', { 'product-title-if-not-visible bg-white d-inline-flex w-100 align-items-center justify-content-between': isTitleVisible }]">
            <h4 style="word-break: break-all;" v-if="isTitleVisible">
              {{ specificProduct.product_details.name }}
            </h4>
            <img
              src="@/assets/images/ic-circle-close.svg"
              width="40px"
              class="close-btn"
              data-dismiss="modal"
              style="cursor:pointer; float: right; padding: 5px;"
              @click="hideModal()"
              alt="Close"
            />
          </div>
        </div>
      </template>
      <template v-slot:default>
        <div class="food-desc">
          <h2 class="mb-10" id="productNameDetailsUpdate">{{ specificProduct.product_details.name }}</h2>
          <p>{{ specificProduct.product_details.description }}</p>
        </div>
        <template v-if="specificProduct.product_details.type == 'simple'">
          <div class="food-choices"></div>
        </template>
        <template v-else>
          <div class="divider"></div>
          <div
            class="food-choices"
            v-for="(attribute, index) in formattedAttributes[
              specificProduct.product_details.name.toLowerCase()
            ]"
            :key="index"
          >
            <div>
              <h2 class="d-inline-block mr-2">{{ `Choose ${attribute.name}` }}</h2>
              <span class="invalid-feedback d-inline">
                {{ invalidFeedback(attribute.name.toLowerCase()) }}
              </span>
            </div>
            <b-form-group>
              <b-form-radio
                v-for="(variation, index) in attribute.variations"
                :key="index"
                :name="attribute.name"
                :value="variation.hash"
                disabled
                v-model="
                  selectedVariations[
                    specificProduct.product_details.name.toLowerCase()
                  ][attribute.name.toLowerCase()]
                "
                @change="
                  selectVariation(
                    specificProduct.product_details.name.toLowerCase(),
                    attribute.name.toLowerCase(),
                    variation.hash
                  )
                "
                >{{ variation.name }}
              </b-form-radio>
            </b-form-group>
          </div>
        </template>
        <!-- Start: Add-Ons -->
        <template
          v-if="specificProduct.product_details.add_on_category.length > 0"
        >
          <div class="divider"></div>
          <div class="food-choices">
            <b-form-group
              v-for="(addon, index) in specificProduct.product_details
                .add_on_category"
              :key="`addOn_category${index}`"
            >
              <h2 class="mb-2">
                {{
                  `${addon.name} (${
                    addOns[`${addon.id}`] === undefined
                      ? 0
                      : addOns[`${addon.id}`].length
                  }/${addon.limit})`
                }}
              </h2>
              <b-form-checkbox-group
                stacked
                v-model="addOns[`${addon.id}`]"
                class="addons-checkbox-group"
              >
                <b-form-checkbox
                  v-for="(item, itemIndex) in addon.add_ons"
                  :key="`addOn_item${itemIndex}`"
                  :value="`${addon.id}|${item.uuid}`"
                  disabled
                >
                  <span>
                    {{ item.name }}
                  </span>
                  <small v-if="!item.is_free">{{
                    `+ P${item.currency
                      .toLowerCase()
                      .substring(1)} ${item.price.toFixed(2)}`
                  }}</small>
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </div>
        </template>
        <!-- End: Add-Ons -->
        <div class="divider"></div>
        <div class="food-choices">
            <b-form-group>
              <h2 class="mb-2">
              Notes
              </h2>
              <b-form-textarea
                id="textarea"
                :value=remarks
                rows="3"
                max-rows="6"
                maxlength="149"
                disabled
              ></b-form-textarea>
              </b-form-group>
        </div>
      </template>
      <template v-slot:modal-footer>
        <div id="modal-footer" class="d-flex flex-column flex-md-row w-100 align-items-center justify-content-between">
          <div class="increase-item d-inline-flex align-items-center">
            <button class="btn p-0" @click="subtractQuantity()" :disabled="quantity < 2">
              <FillableMinusIcon
                :fill-color="webDesign && webDesign.design ? webDesign.design.main_color : '#ff8a00'"
                :button-text-color="webDesign && webDesign.design ? webDesign.design.button_text_color : '#FFFFFF'"
              />
            </button>
            <input 
              type="number" 
              class="item-count" 
              v-model="quantity" 
              min="1" 
              :max="maxOrder"
              disabled
            />
            <button class="btn p-0" @click="addQuantity()">
              <FillablePlusIcon
                :fill-color="webDesign && webDesign.design ? webDesign.design.main_color : '#ff8a00'"
                :button-text-color="webDesign && webDesign.design ? webDesign.design.button_text_color : '#FFFFFF'"
              />
            </button>
          </div>
          <div class="d-flex flex-column flex-md-row align-items-center mt-3 mt-md-0">
            <button
              :disabled="estoreIsLoading"
              @click="addToCart()"
              type="button"
              class="btn btn-core w-240"
              v-if="webDesign !== null && webDesign.design !== null"
              :style="{
                backgroundColor: webDesign.design.main_color + '!important',
                border: 'none !important',
                color: webDesign.design.button_text_color + '!important'
              }"
            >
              UPDATE CART
              {{
                ` - PHP ${putComma((parsedPrice * quantity + addOnsCharges).toFixed(2))}`
              }}
            </button>
            <button
              :disabled="estoreIsLoading"
              @click="addToCart()"
              type="button"
              class="btn btn-core w-240"
              v-else
            >
              UPDATE CART
              {{
                ` - PHP ${putComma((parsedPrice * quantity + addOnsCharges).toFixed(2))}`
              }}
            </button>
          </div>
        </div>
      </template>
    </b-modal>
    <!-- Stocks Modal -->
    <b-modal ref="stocksModal" hide-footer>
      <div class="modal-body aCenter" v-if="estoreErrors">
        <img src="@/assets/images/info.svg" class="mt-10" alt="Information" />
        <p v-if="estoreErrors && estoreErrors.errors">
          {{estoreErrors.errors.message}}
        </p>
      </div>
      <div class="modal-body aCenter" v-else>
        <img src="@/assets/images/info.svg" class="mt-10" alt="Information" />
        <p>Quantity should not be more than the current stock.</p>
        <p>
          Current Stock: <strong>{{ this.stock }}</strong>
        </p>
      </div>
    </b-modal>
  </b-overlay>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import FillablePlusIcon from "@/components/fillable-plus-icon";
import FillableMinusIcon from "@/components/fillable-minus-icon";

export default {
  components: { FillablePlusIcon, FillableMinusIcon },
  computed: {
    ...mapState("auth", {
      token: state => state.token,
      authErrors: state => state.errors,
      authIsLoading: state => state.loading
    }),
    ...mapState("merchant", {
      subdomain: state => state.subdomain,
      customerPortalToken: state => state.customerPortalToken,
      merchantIsLoading: state => state.loading,
      merchantErrors: state => state.errors
    }),
    ...mapState("branch", {
      branches: state => state.branches,
      branchesNearby: state => state.branchesNearby,
      branchesErrors: state => state.errors,
      branchesIsLoading: state => state.loading,
      specificBranch: state => state.specificBranch,
      coordinates: state => state.coordinates
    }),
    ...mapState("estore", {
      products: state => state.products,
      estoreIsLoadingOverlay: state => state.loadingOverlay,
      estoreIsLoading: state => state.loading,
      estoreErrors: state => state.errors,
      specificProduct: state => state.specificProduct,
      cart: state => state.cart,
      webDesign: state => state.webDesign
    }),
    ...mapGetters({
      loggedIn: "auth/loggedIn",
      firstBranchNearby: "branch/firstBranchNearby",
      cartUuid: "estore/cartUuid"
    }),
    addOnsCharges() {
      // Computed Property for Add Ons Total Charges
      let total = 0;
      const addOns = this.specificProduct.product_details.add_on_category;
      Object.keys(this.addOns).map(id => {
        this.addOns[`${id}`].map(item => {
          const addOnData = addOns
            .find(category => category.id === Number(id))
            .add_ons.find(addon => addon.uuid === item.split("|")[1]);
          total = total += addOnData.is_free ? 0 : addOnData.price;
        });
      });
      return total * this.quantity;
    }
  },
  data() {
    return {
      quantity: 1,
      maxOrder: 1,
      simpleSelected: false,
      itemUuid: null,
      branchUuid: null,
      formattedSpecificProduct: null,
      formattedAttributes: {},
      selectedVariations: {},
      variationProductTotal: "",
      parsedVariationCode: null,
      parsedPrice: null,
      stock: null,
      addOns: {},
      isTitleVisible: false,
      remarks:""
    };
  },
  mounted() {
    this.$root.$on('bv::modal::shown', (event, id) => {
      if (id === 'product_details') {
        const modal_body = document.querySelector('.modal-body');
        const product_title = document.getElementById('productNameDetailsUpdate');
        const isInModalView = function (elem) {
          const bounding = elem.getBoundingClientRect();
          return bounding.top <= modal_body.offsetHeight + (bounding.height * 2);
        };
        modal_body.addEventListener('scroll', () => {
          this.isTitleVisible = isInModalView(product_title);
        });
      }
    });
  },
  methods: {
    getIndex(index) {
      return index;
    },
    async showModal(branch_uuid, product_uuid, item_uuid, stock, is_limited_stock) {
      this.$store.commit("estore/RESET_ERRORS");
      if(is_limited_stock == 0) {
        this.unlimitedStock = true;
      } else {
        this.unlimitedStock = false;
        this.maxOrder = stock;
      }
      
      this.itemUuid = item_uuid;
      this.branchUuid = branch_uuid;

      this.formattedAttributes = {};
      this.selectedVariations = {};
      this.variationProductTotal = "";

      for (let i = 0; i < this.cart.list.length; i++) {
        for (let j = 0; j < this.cart.list[i].items.length; j++) {
          if (item_uuid == this.cart.list[i].items[j].uuid) {
            this.quantity = parseInt(this.cart.list[i].items[j].quantity);
            // Parse Variation Code and Regular Price
            if (
              this.cart.list[i].items[j].product_inventory.product_details
                .type == "variable"
            ) {
              this.parsedVariationCode = this.cart.list[i].items[
                j
              ].product_inventory.variation_code.split("_");
              if (this.cart.list[i].items[j].product_inventory.on_sale) {
                if (
                  this.$moment(
                    this.cart.list[i].items[j].product_inventory.on_sale_to
                  ).isBefore(this.$moment())
                ) {
                  this.parsedPrice = this.cart.list[i].items[
                    j
                  ].product_inventory.regular_price;
                } else {
                  this.parsedPrice = this.cart.list[i].items[
                    j
                  ].product_inventory.sale_price;
                }
              } else {
                this.parsedPrice = this.cart.list[i].items[
                  j
                ].product_inventory.regular_price;
              }
            } else {
              if (this.cart.list[i].items[j].product_inventory.on_sale) {
                if (
                  this.$moment(
                    this.cart.list[i].items[j].product_inventory.on_sale_to
                  ).isBefore(this.$moment())
                ) {
                  this.parsedPrice = this.cart.list[i].items[
                    j
                  ].product_inventory.regular_price;
                } else {
                  this.parsedPrice = this.cart.list[i].items[
                    j
                  ].product_inventory.sale_price;
                }
              } else {
                this.parsedPrice = this.cart.list[i].items[
                  j
                ].product_inventory.regular_price;
              }
            }
            // SET ADD ONS
            const obj = {};
            this.cart.list[i].items[j].add_ons.map(item => {
              obj[item.product_add_on_category_id] = [];
              this.$nextTick(() => {
                obj[item.product_add_on_category_id].push(
                  `${item.product_add_on_category_id}|${item.uuid}`
                );
              });
            });
            this.addOns = obj;
            this.remarks = this.cart.list[i].items[j].remarks;
          }
        }
      }

      let _this = this;

      let request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          product_uuid: product_uuid,
          branch_uuid: branch_uuid
        }
      };

      if (this.loggedIn) request.header["Authorization"] = this.token;

      await this.$store
        .dispatch("estore/getSpecificProduct", request)
        .then(() => {
          if (this.estoreErrors == null) {
            _this.formatSpecificProduct();
          }
        });
    },
    hideModal() {
      this.isTitleVisible = false;
      this.$refs.modal.hide();
    },
    addQuantity() {
      if(this.unlimitedStock) {
        this.quantity++;
      } else {
        if(this.quantity < this.maxOrder)
          this.quantity++;        
      } 
    },
    subtractQuantity() {
      if (this.quantity <= 1) {
        console.log("Minimum quantity should be 1.");
      } else {
        this.quantity--;
      }
    },
    async addToCart() {
      this.$store.commit("estore/RESET_ERRORS");
      let request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          quantity: this.quantity,
          remarks: this.remarks,
          customer_lat: this.coordinates.lat,
          customer_lng: this.coordinates.long
        },
        cart_item_uuid: {
          cart_item_uuid: this.itemUuid
        }
      };

      if (this.loggedIn) request.header["Authorization"] = this.token;
      else {
        delete request.cart_item_uuid;
        delete request.payload.customer_lat;
        delete request.payload.customer_lng;
        request.payload["cart_item_uuid"] = this.itemUuid;
        request.payload["cart_uuid"] = this.cartUuid;
      }
       
      let _this = this;
      await this.$store.dispatch("estore/editCart", request).then(() => {
        if (!_this.estoreErrors) {
          _this.$root.$emit("refreshCartItems");
          _this.hideModal();
        } else {
          this.$refs["stocksModal"].show();
        }
      });
    },
    formatSpecificProduct() {
      let specificProductName = this.specificProduct.product_details.name.toLowerCase();
      let specificProductAttributes = this.specificProduct.product_details
        .attributes;

      this.formattedAttributes[specificProductName] = [];
      this.selectedVariations[specificProductName] = {};
      specificProductAttributes.forEach(attribute => {
        let attributeName = attribute.name.toLowerCase();
        this.formattedAttributes[specificProductName].push(attribute);
        this.selectedVariations[specificProductName][attributeName] = "";
        for (let index = 0; index < this.parsedVariationCode.length; index++) {
          let parsedVariationCodeExists = attribute.variations.find(
            variation => variation.hash == this.parsedVariationCode[index]
          );
          if (parsedVariationCodeExists != undefined) {
            this.selectedVariations[specificProductName][attributeName] =
              parsedVariationCodeExists.hash;
          }
        }
      });

      this.$refs.modal.show();
    },
    invalidFeedback(field) {
      if (this.estoreErrors == null) {
        return "";
      }
      return this.estoreErrors.errors[field];
    },
    state(field) {
      if (this.estoreErrors == null) {
        return false;
      }
      return this.estoreErrors.errors[field] ? false : true;
    },
    selectVariation(productName, attributeName, variationHash) {
      this.selectedVariations[productName][attributeName] = variationHash;

      let selectedVariations = this.selectedVariations[productName];

      let attributeNames = this.formattedAttributes[
        productName
      ].map(attribute => attribute.name.toLowerCase());

      let variationCode = "";
      for (let index = 0; index < attributeNames.length; index++) {
        const attributeName = attributeNames[index];
        variationCode += "_" + selectedVariations[attributeName];
      }

      let inventory = this.specificProduct.product_details.inventory.filter(
        inventory => inventory.variation_code === variationCode.substr(1)
      );

      if (inventory.length > 0) {
        this.variationProductTotal = inventory[0].regular_price;
      }
    },
    putComma(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>
<style lang="scss" scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>

<style lang="scss">
.product-title-if-not-visible {
  transition: all ease 0.2s;
  h4 {
    font-size: 20px !important;
  }
}
</style>
